import { isNotDefined } from '@sgme/fp';

import type { FlexiForwardQuote, FlexiForwardRfs } from '@/store/flexi-forward/state';

export function getFlexiForwardQuote(rfsState: FlexiForwardRfs | undefined): FlexiForwardQuote | undefined {
  if (isNotDefined(rfsState)) {
    return undefined;
  }

  return rfsState.status === 'PRICING' || rfsState.status === 'EXPIRED' ? rfsState.quote : undefined;
}

export function getFlexiForwardRfsId(rfsState: FlexiForwardRfs | undefined): string | undefined {
  if (isNotDefined(rfsState)) {
    return undefined;
  }

  return rfsState.status === 'AWAITING' || rfsState.status === 'PRICING' || rfsState.status === 'ERROR'
    ? rfsState.rfsId
    : undefined;
}

export function getFlexiForwardRfsQuoteId(rfsState: FlexiForwardRfs | undefined): string | undefined {
  if (isNotDefined(rfsState)) {
    return undefined;
  }

  return rfsState.status === 'PRICING' ? rfsState.quoteId : undefined;
}
